
export default defineNuxtPlugin(async(NuxtApp) => {
  window.addEventListener("beforeinstallprompt", function(event: any) {
    if(!event.prompt) {
      console.info('该浏览器不支持')
    }
  
    usePWAPrompt().value = event
  })
})
